import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { Route } from '../Routes';
import { FolderOpen } from 'lucide-react';
import { PrimaryColor } from '../../styles/global/css/Utils';
import { FileManager } from '../../containers_v2/documents/filemanager';

const FileManagerRoutes = (): Route[] => [
	{
		component: FileManager,
		path: '/filemanager',
		key: 'documents',
		sectionKey: 'documents',
		logoImg: <FolderOpen size='16' />,
		hoverImg: <FolderOpen color={PrimaryColor} size='16' />,
		activeImg: <FolderOpen color={PrimaryColor} size='16' />,
		permission: ['ViewDoc'],
		title: 'Documents',
		subTitle: 'Documents',
		admin: false,
		name: <Translate id="documents" />,
		restricted: false,
		menu: true,
		exact: true,

	}
];

export default FileManagerRoutes;
